const MINHA_OFERTA_TV_URL = 'https://mo.hubmaster.com.br';

/** O alvo do player (`chrome >= 53`, no `plugin-legacy` de `minha-oferta-tv`). */
const PLAYER_MIN_CHROME = 53;

interface MoveInput {
	isTV: boolean;
	functions?: readonly string[];
	token?: string;
	userAgent: string;
	rotation: number;
	baseUrl?: string;
}

/**
 * A versão do motor. A Samsung (Tizen) costuma dizer `76.0.3809.146/6.0 TV`, sem a
 * palavra Chrome, e motor que não se identifica fica como desconhecido.
 */
export function chromeMajorOf(userAgent: string): number | null {
	const match =
		/Chrome\/(\d+)/.exec(userAgent) ??
		/\b(\d+)\.\d+\.\d+\.\d+\/\d+(?:\.\d+)* TV\b/.exec(userAgent);
	return match ? Number(match[1]) : null;
}

/** Na dúvida fica: aqui a TV funciona, e num motor antigo o player seria tela preta. */
export function runsPlayer(userAgent: string): boolean {
	const major = chromeMajorOf(userAgent);
	return major !== null && major >= PLAYER_MIN_CHROME;
}

/** A marca sozinha não basta: token sem `offers` é só leitor e não migra (D12). */
export function isMovedToken(functions?: readonly string[]): boolean {
	return (
		!!functions &&
		functions.includes('offers') &&
		functions.includes('offers_moved')
	);
}

/**
 * Token marcado não se perde pelo limite: a TV vai para o Minha Oferta com ele, e outro
 * aparelho no mesmo token fica tentando em vez de cair no login.
 */
export function keepsTokenOnLimit(
	code: string,
	functions?: readonly string[],
): boolean {
	return code === 'limit_single_connection' && isMovedToken(functions);
}

/** O erro do socket que apaga o token e leva ao login. */
export function losesToken(
	code: string,
	functions?: readonly string[],
): boolean {
	return (
		code === 'token_invalid' ||
		(code === 'limit_single_connection' && !isMovedToken(functions))
	);
}

/**
 * Para onde vai a TV com ofertas cujo token foi marcado, ou nulo para ela ficar.
 *
 * TV só com o leitor fica no Consulta Preço (D12), e o celular com o mesmo token
 * também, como o aparelho que não roda o player. A marca é por token: publicar este
 * código não move TV nenhuma.
 *
 * O token vai no fragmento, que não chega ao servidor nem aos logs de quem serve a página.
 */
export function offersTvMoveUrl({
	isTV,
	functions,
	token,
	userAgent,
	rotation,
	baseUrl,
}: MoveInput): string | null {
	if (!isTV || !token || !isMovedToken(functions)) return null;
	if (!runsPlayer(userAgent)) return null;
	const base = (baseUrl || MINHA_OFERTA_TV_URL).replace(/\/+$/, '');
	return `${base}/?origem=consulta-preco&giro=${rotation}#token=${encodeURIComponent(token)}`;
}
